import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import ItiDataTable from '../data-table/iti-data-table.vue';
import { EventAddClick, EventEditClick, EventRemoveClick } from '..';

@Component({
    components: {
        ItiDataTable
    }
})

export default class ItiList extends Vue {
    @Prop() public title!: string;
    @Prop() public columns!: any[];
    @Prop() public items!: any[];
    @Prop() public icon!: string;
    @Prop() public loading!: string;
    @Prop({ default: false }) public hideActions!: boolean;
    @Prop() public buttons!: any[];
    @Prop({
        default: () => [
            10,
            25,
            50,
            { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 },
        ],
    })
    @Prop({ default: 'Buscar' }) public searchText!: string;
    @Prop({ default: 'No hay resultados para la búsqueda' })
    public noResultsText!: string;
    @Prop({ default: '' }) public color!: string;
    @Prop({ default: false }) public flat!: boolean;
    @Prop({ default: false }) public searchHidden!: boolean;
    @Prop({ default: true }) public showButtonAdd!: boolean;

    public search = '';
    public addHidden = true;

    constructor() {
        super();
    }

    public newItem(){
        this.$emit(EventAddClick);
    }

    public editItem(event: any){
        this.$emit(EventEditClick, event);
    }

    public removeItem(event: any){
        this.$emit(EventRemoveClick, event);
    }
}
